import React, { Children, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";

const Rules = (children) => {
  let { toggle,updateOpen,setupdateOpen } = children;

  const navigate = useNavigate();
  const navigateToContacts = () => {
    // 👇️ navigate to /contacts
    navigate("/Themes");
  };
  const RulesList = [
    {
      Rules:
        "If Solutionec finds your contribution, hack, or code to be extraordinary or of high significance/relevance, it's possible that they may express interest in acquiring the intellectual property (IP) rights associated with it. In such situations, it is crucial for both parties (you, as the creator, and Solutionec) to establish clear and legally binding agreements to protect the interests of all involved including profit sharing with the creator.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        "This is an individual/team participation hackathon. You can have at most 5 members in your team.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        'Participants are expected to submit concept documents under "Blueprint File" and "Architecture File" in the registration form. The final hack or project can be submitted by clicking on the ',
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    
    {
      Rules:
        "Individuals matching the eligibility criteria can enter the competition.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        "The idea phase of the hackathon will start on 11/09/2023 at 10:00 AM IST and end on at 13/10/2023 11:59 PM IST, you can work on your hack and submit your ideas within the allotted time only.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules: "It's an online hackathon; you can participate from anywhere. If you are shortlisted, you and your team must be physically present at the final event's venue.",
      sup:"",
      secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules: `Participants must submit a hack that is related to the mentioned `,
      sup:"",
      secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        "Once the hackathon starts, you will get an option to submit your hack. You can continue to edit and resubmit your hack until the deadline and the last hack will be considered as the final submission.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    // {
    //   Rules: "The submission files should be named in ",
    //   hyperlink: "",
    //   hyperlinktext: "TeamName_Date of submission (DD_MM_YY)_BluePrint or TeamName_Date of submission (DD_MM_YY)_Architecture",
    // },
    {
      Rules:
        "You are expected to come up with new and innovative ideas, any idea that has been copied or plagiarised will be disqualified.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        "There will be no travel and stay reimbursement for the onsite hackathon.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules: "In-person hackathon (November 27",
      sup:"th",
      secondrule:", 2023) and finale will be held at",
      hyperlink:
        "https://www.google.com/maps/dir/12.992741,77.7035726/iit+bombay+location/@16.0462758,72.6639112,7z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3be7c7f189efc039:0x68fdcea4c5c5894e!2m2!1d72.9132679!2d19.1334302?entry=ttu",
      hyperlinktext: " IIT Bombay.",
    },
    {
      Rules:
        "Your hack must be developed entirely during the Hackathon duration. You may use open-source libraries and other freely available systems/services.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
    {
      Rules:
        "By participating in the hackathon, you agree to the terms and conditions of Solutionec.",
        sup:"",
        secondrule:"",
      hyperlink: "",
      hyperlinktext: "",
    },
  ];
  useEffect(() => {
    toggle();
  }, []);
  return (
    <Box style={{ marginBottom: "50px", marginLeft: "1rem",marginRight:'1rem' }}>
      <p className="main-title">RULES</p>
      <Box>
        {RulesList.map((itinerary, i) => (
          <div>
            {i == 6 ? 
            
            (
              <ul className="main-titletheams"  style={{ textAlign:"justify"}}>
                {" "}
                <li>
                  {" "}
                  {itinerary.Rules}
                  
                  <span
                    style={{
                      fontFamily: "Arial, Verdana, sans-serif",
                      fontWeight: "bold",
                      color: "#052a58",
                      cursor: "pointer",
                    }}
                    onClick={navigateToContacts}
                  >
                    theme
                  </span>{" "}
                  and requirements.
                </li>
              </ul>
            ) : i === 2 ?
            (
              <ul className="main-titletheams"  style={{ textAlign:"justify"}}>
                {" "}
                <li>
                  {" "}
                  {itinerary.Rules}
                  
                  <span
                    style={{
                      fontFamily: "Arial, Verdana, sans-serif",
                      fontWeight: "bold",
                      color: "#052a58",
                      // cursor: "pointer",
                    }}
                    // onClick={()=>setupdateOpen(true)}
                  >
                    Already Registered
                  </span>{" "}
                  option on the homepage on or before the deadline.
                </li>
              </ul>
             
            ):( <ul className="main-titletheams" style={{ textAlign:"justify"}}>
            {" "}
            <li>
              {" "}
              {itinerary.Rules}
              <sup>
                {itinerary.sup}
              </sup>
              <span>
                {itinerary.secondrule}
              </span>
              <a
                className="sub-title"
                style={{
                  fontFamily: "Arial, Verdana, sans-serif",
                  marginLeft: "1px",
                  color: "#052a58",
                  textAlign:"justify"
                }}
                href={itinerary.hyperlink}
                target="_blank"
              >
                {itinerary.hyperlinktext}
              </a>
            </li>
          </ul>)}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default Rules;
